export default "__VITE_ASSET__b591da23__"